export const center_app_version = {"commit_sha": "dda5f47a"}
